import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

const UploadControls = ({ 
    fileInputRef, 
    handleFileChange, 
    triggerFileSelect, 
    selectedFiles, 
    setOpenModal 
}) => {
    return (
        <>
            <Box display="flex" justifyContent="center" my={2}>
                {/* ファイル選択用の非表示インプット */}
                <input 
                    type="file" 
                    accept="image/*" 
                    multiple 
                    hidden 
                    ref={fileInputRef} 
                    onChange={handleFileChange} 
                />

                {/* アップロードボタン */}
                <Button 
                    variant="contained" 
                    color="primary" 
                    size="large" 
                    onClick={triggerFileSelect}
                >
                    画像をアップロード
                </Button>

                {/* 画像一覧ボタン */}
                {selectedFiles.length > 0 && (
                    <Button 
                        variant="outlined" 
                        color="secondary" 
                        onClick={() => setOpenModal(true)}
                        startIcon={<ImageIcon />}
                        sx={{ ml: 2 }}
                    >
                        アップロードした画像一覧
                    </Button>
                )}
            </Box>

            {/* アップロードした画像の枚数表示 */}
            {selectedFiles.length > 0 && (
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <Typography variant="h6" color="primary">
                        {selectedFiles.length} 枚の画像をアップロードしました
                    </Typography>
                </Box>
            )}
        </>
    );
};

export default UploadControls;
